import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { IconAiAgentSolid } from "../IconAiAgent";

import {
  DASHBOARD,
  AI_TOOL_MANAGEMENT,
  ACCOUNT_MANAGEMENT_TRANSACTIONS,
  PARTNER_MANAGEMENT_PARTNERS,
  PARTNER_MANAGEMENT_CREATE_PARTNER,
} from "../../constants/routes";

export const content = {
  title: "ContentUiShell",
  navigation: [
    {
      title: `Dashboard`,
      route: DASHBOARD,
      icon: DashboardIcon,
    },
    {
      title: `AI Tool Management`,
      route: AI_TOOL_MANAGEMENT,
      icon: IconAiAgentSolid,
    },
    {
      title: `Account Management`,
      route: null,
      icon: ManageAccountsIcon,
      navigation: [
        {
          title: `Transactions`,
          route: ACCOUNT_MANAGEMENT_TRANSACTIONS,
          icon: null,
        },
        // {
        //   title: `Billing Details`,
        //   route: ACCOUNT_MANAGEMENT_BILLING_DETAILS,
        //   icon: null,
        // },
        // {
        //   title: `User Management`,
        //   route: ACCOUNT_MANAGEMENT_USER_MANAGEMENT,
        //   icon: null,
        // },
      ],
    },
    {
      title: `Partner Management`,
      route: null,
      icon: GroupWorkIcon,
      navigation: [
        {
          title: `Partners`,
          route: PARTNER_MANAGEMENT_PARTNERS,
          icon: null,
        },
        {
          title: `Create Partner`,
          route: PARTNER_MANAGEMENT_CREATE_PARTNER,
          icon: null,
        },
      ],
    },
  ],
};
